module.exports = __webpack_public_path__ + "img/full2-min.2f8d51ff.png";